export default "__VITE_ASSET__66381187__"